<template>
  <div v-if="test" class="d-flex justify-content-between mb-24 text-blue-03">
    <div>Завершено на {{ (100 * answeredLength/test.questionsCount).toFixed(0) }}%</div>
    <vue-countdown  :time="getTime()" :transform="transform" @end="onEnd">
      <template slot-scope="props">
        <div class="card__duration">{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</div>
      </template>
    </vue-countdown>
  </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import moment from "moment/moment";
export default {
  name: "TestStartProgress",
  components: {VueCountdown},
  props: {
    test: {
      type: Object,
      default() {
        return null
      }
    },
    answeredLength: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  data() {
    return {
      endAt: this.getServerEndAt()
    }
  },
  methods: {
    getServerEndAt() {
      // Тест с порогом зачёта завершается по таймеру: конец попытки берём из серверного снимка timer,
      // а не из часов слушателя (если они спешат, попытка закрылась бы раньше времени)
      const test = this.test
      const timer = test && test.timer
      if (!test || test.pass_percent === null || test.pass_percent === undefined || !timer) {
        return null
      }
      const left = timer.invert ? ((Number(timer.h) * 3600) + (Number(timer.i) * 60) + Number(timer.s)) * 1000 : 0
      return Date.now() + left
    },
    getTime() {
      if (this.endAt !== null) {
        return Math.max(0, this.endAt - Date.now())
      }
      const end  = moment(this.test.start).add(this.test.duration, 'minutes')
      const start = moment()
      return end - start
    },
    onEnd() {
      // Время попытки вышло: завершать ли тест, решает Test.vue
      this.$emit('end')
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });

      return props;
    },
  }
}
</script>

<style scoped>

</style>